import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { matDialogAnimations } from '@angular/material/dialog';
import * as jwt_decode from 'jwt-decode';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { User } from '../../../models/user.model';
import { Config } from '../order/config.service';
/**
 * Service quản lý xác thực và kiểm duyệt phân quyền
 * Note: Service này (nên) không phụ thuộc vào các service (#) trong hệ thống
 */
@Injectable()
export class AuthenticationService {
  private LOGIN_URL: string;

  public currentUserSubject: BehaviorSubject<User>;
  public currentUserRole: BehaviorSubject<any>;
  public currentUserInfo: Observable<User>;
  currentRoute: any = [
    '/home',
    '/score-detail',
    '/student-edit',
    '/monthly-comment-detail',
    '/score-sheet-lock',
    '/all-score-export',
    '/report-semester-to-parent-print',
    '/profile/overview',
    '/monthly-comment-lock'
  ];

  /**
   * Lưu ý AuthService độc lập & không phụ thuộc vào AppService khác
   * @param http
   * @param logger
   */
  constructor(private http: HttpClient, private config: Config) {
    const vUser = User.fromJSON(localStorage.getItem('currentUser'));
    this.currentUserSubject = new BehaviorSubject<User>(vUser);
    this.currentUserInfo = this.currentUserSubject.asObservable();
    this.getRole();
  }

  /**
   * Lấy thông tin người dùng hiện tại
   */
  public get currentUser(): User {
    return this.currentUserSubject.value;
  }

  public get currentRole() {
    return this.currentUserRole.value;
  }

  /**
   * Tracking login / logout
   */
  public get observableUser(): Observable<User> {
    return this.currentUserInfo;
  }

  /**
   * Login for valid user
   * @param username
   * @param password
   */

  getRole() {
    const vRole = [];
    let arr = JSON.parse(localStorage.getItem('menu'));
    if (arr && arr.length > 0) {
      arr.map((item) => {
        if (item.State) {
          return vRole.push(item.State);
        }
      });
    }

    this.currentUserRole = new BehaviorSubject<any>([
      ...vRole,
      ...this.currentRoute,
    ]);
  }

  login(domain: string, username: string, password: string) {
    const body = {
      username,
      password,
      domain,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    this.LOGIN_URL = `${environment.baseUrl}/api/user/login`;
    return this.http.post<User>(this.LOGIN_URL, body, httpOptions).pipe(
      map(async (user: any) => {
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          // store user details in local storage to keep user
          localStorage.setItem('currentUser', JSON.stringify(user));
          if (user.idNhiemVu == null) {
            var menu = await this.config.getMenu(domain, user.groupId);
            menu.forEach(element => {
              if (element.Params)
                element.Params = JSON.parse(element.Params);
            });
            localStorage.setItem('menu', JSON.stringify(menu));
            this.getRole();
          }

          var setting = this.config.getCompanySetting(domain).subscribe((res) => {
            var data = this.config.GetDataFromResult(res);
            localStorage.setItem(`companySetting`, JSON.stringify(data));
            this.config.checkLoad();
          });

          await this.config.GetDefaultFilter().subscribe((res) => {
            localStorage.setItem('default-filter', JSON.stringify(res[0]));
          });

          user = User.from(user);
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  /**
   * Log user out
   */
  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('currentUser');
    let domain = localStorage.getItem('domain');
    localStorage.clear();
    if (domain) {
      localStorage.setItem('domain', domain);
    }
    this.currentUserSubject.next(null);
    window.location.reload();
  }

  /**
   * Token hết hạn chưa
   * @param expires
   */
  isTokenExpired(expires: Date): boolean {
    return expires.valueOf() < new Date().valueOf();
  }

  /**
   * Tài khoản đã được xác thực hay chưa
   */
  isAuthenticated(): boolean {
    const vUser = this.currentUser;
    if (vUser == null || vUser.token == null) {
      return false;
    }
    const exp = new Date(0);
    // exp.setUTCSeconds(vUser.token.exp);
    return !this.isTokenExpired(exp);
  }

  /**
   * Tài khoản có quyền hay không
   * Được sử dụng và check trong Guards
   * @param allowedRoles
   */
  isAuthorized(allowedRoles: string[] | null): boolean {
    // check if the list of allowed roles is empty, if empty, authorize the user
    // to access the page
    if (allowedRoles == null || allowedRoles.length === 0) {
      return true;
    }

    // get token from local storage or state management
    const token = this.currentUser.token;

    // check if it was decoded successfully, if not the token is not valid, deny
    // access

    let userRoles = this.currentUser.role.split('|');

    // check if the user roles is in the list of allowed roles, return true if
    // allowed and false if not allowed
    return userRoles.some((x) => allowedRoles.includes(x));
  }
}
